import React from 'react';
import { RouterProvider } from 'react-router/dom';
import router from '@triplabo/web/routes';
import { store, StoreProvider } from '@triplabo/web/stores';

const App: React.FC = () => {
  return (
    <StoreProvider value={store}>
      <RouterProvider router={router} />
    </StoreProvider>
  );
};

export default App;
